// Export all images for programmatic imports

// Portraits
import capitol from './portraits/capitol.jpg';
import caves from './portraits/caves.jpg';
import homeBackground from './portraits/home-background.jpg';
import newYorkFit from './portraits/new-york-fit.jpg';
import rixosMarina from './portraits/rixos-marina.jpg';
import traditional from './portraits/traditional.jpg';

// Technology icons
import apple from './technology/apple.svg';
import aws from './technology/aws-logo.jpeg';
import awsSaa from './technology/aws-saa.png';
import bash from './technology/bash.svg';
import c from './technology/c.svg';
import claudeCode from './technology/claude-code.png';
import codex from './technology/codex.jpg';
import cpp from './technology/cpp.svg';
import cursor from './technology/cursor.png';
import css3 from './technology/css3.svg';
import dart from './technology/dart.svg';
import docker from './technology/docker.svg';
import flutter from './technology/flutter.svg';
import gcp from './technology/gcp-logo.png';
import html5 from './technology/html5.svg';
import java from './technology/java.svg';
import javascript from './technology/javascript.svg';
import linux from './technology/linux.svg';
import mysql from './technology/mysql.svg';
import postgresql from './technology/postgresql.svg';
import postman from './technology/postman.svg';
import python from './technology/python.svg';
import react from './technology/react.svg';
import windows11 from './technology/windows11.svg';

// Interests
import f1 from './interests/f1.jpg';

// Export as organized objects
export const portraits = {
  capitol,
  caves,
  homeBackground,
  newYorkFit,
  rixosMarina,
  traditional
};

export const technology = {
  apple,
  aws,
  awsSaa,
  bash,
  c,
  claudeCode,
  codex,
  cpp,
  cursor,
  css3,
  dart,
  docker,
  flutter,
  gcp,
  html5,
  java,
  javascript,
  linux,
  mysql,
  postgresql,
  postman,
  python,
  react,
  windows11
};

export const interests = {
  f1
};
